import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { deviceStore } from '@/stores/deviceStore';
import { formatNumber, formatTime } from '@/utils/formatters';
import { Card } from '@/components/ui/card';
import { Loader2 } from 'lucide-react';

export const DashboardSummary = observer(() => {
  const { t } = useTranslation();
  const { devices, summary, loading } = deviceStore;
  
  if (loading) {
    return (
      <div className="flex items-center justify-center h-40">
        <Loader2 className="h-8 w-8 animate-spin" />
      </div>
    );
  }
  
  return (
    <div className="space-y-6">
      <h2 className="text-2xl font-bold">{t('dashboard.systemOverview')}</h2>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <Card className="p-6 flex flex-col items-center justify-center">
          <div className="text-sm font-medium text-gray-500">{t('dashboard.totalDevices')}</div>
          <div className="text-3xl font-bold mt-2">{devices.length}</div>
        </Card>
        
        <Card className="p-6 flex flex-col items-center justify-center">
          <div className="text-sm font-medium text-gray-500">{t('dashboard.totalConsumption')}</div>
          <div className="text-3xl font-bold mt-2">
            {summary ? formatNumber(summary.total_consumption) : '--'}
          </div>
          <div className="text-sm text-gray-500">kWh</div>
        </Card>
        
        <Card className="p-6 flex flex-col items-center justify-center">
          <div className="text-sm font-medium text-gray-500">{t('dashboard.lastUpdate')}</div>
          <div className="text-xl font-bold mt-2">
            {summary ? formatTime(summary.latest_update) : '--'}
          </div>
        </Card>
      </div>
    </div>
  );
}); 